var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2106",
    d: "M17.3908 13.1433C17.2708 13.154 17.0812 23.2629 17.0812 24.028C17.0812 27.114 17.0812 30.2 17.0812 33.2861C17.0812 33.9793 16.8876 34.813 17.0984 35.4875C17.4323 36.5558 17.8942 35.7279 18.3198 35.0472C19.0589 33.8648 20.9337 33.0114 21.7947 31.8552C22.0679 31.4882 25.1377 28.6631 25.1492 28.6754C26.1604 29.7537 27.4921 30.7691 28.7789 31.6839C30.134 32.6473 31.5379 33.8961 33.1828 34.5458C33.2996 34.5919 35.2559 35.3755 34.9718 35.5486C34.7308 35.6955 34.731 34.718 34.731 34.6069C34.731 33.653 34.731 32.699 34.731 31.7451C34.731 28.9567 34.731 26.1682 34.731 23.3798C34.731 20.5978 34.4214 17.8554 34.4214 15.1246C34.4214 14.8462 34.2674 13.3917 34.0429 13.1922C33.5907 12.7904 31.1165 13.1433 30.2239 13.1433C25.9462 13.1433 21.6685 13.1433 17.3908 13.1433Z",
    stroke: "#33333A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.30c0bcba5f5ba2ac22f5e01a7650be79.svg";
export { ForwardRef as ReactComponent };